import type { InfractionText } from './types';

export const portInfractions: Record<string, Record<number, InfractionText>> = {
  HIGH_PORT_EXPOSED: {
    22: {
      infraction: '',
      explanation: '',
      risk: '',
    },
  },
  MEDIUM_PORT_EXPOSED: {
    554: {
      infraction: '',
      explanation: '',
      risk: '',
    },
  },
};
